import { useLicenseInfo } from '../../../redux/slices/license/hooks/hooks';
import { useMusic24Plan } from '../../music24/hooks/useMusic24Plan';

/** Days left of the running trial, or null on every other plan (design: onboarding d3). */
export function useTrialDaysLeft(): number | null {
  const licenseInfo = useLicenseInfo();
  const plan = useMusic24Plan();
  if (plan !== 'trial' || !licenseInfo.isTrialActive) {
    return null;
  }
  return licenseInfo.trialDaysRemaining;
}
